/**
 * Merkt sich, welche Bereiche eines Dokuments zugeklappt sind – pro Gerät in
 * `localStorage`, nicht in der Datenbank (Falten ist reine Anzeige, siehe
 * folding.ts). Beim erneuten Öffnen (Reload, Navigation zurück) fällt der
 * Quelltext sonst komplett offen an, obwohl der Nutzer ihn zusammengeklappt
 * hatte – das wirkt „durcheinander", gerade bei langen Notizen.
 *
 * Gespeichert wird bewusst NICHT die reine Zeilennummer: Zeilen verschieben
 * sich bei jeder Bearbeitung oberhalb. Stattdessen zusätzlich der (gekürzte)
 * Text der Kopfzeile – beim Wiederherstellen zählt nur ein Treffer, bei dem
 * Zeile UND Text noch passen. Verschiebt sich etwas, wird die Faltung
 * stillschweigend nicht wiederhergestellt (kein Fehler, kein falsches
 * Zuklappen an der falschen Stelle).
 */

const KEY = "lernapp.folds.v1";
/** Reicht, um Verwechslungen mit Nachbarzeilen auszuschließen. */
const SNIPPET_LEN = 60;

export interface FoldMark {
  line: number;
  head: string;
}

function readAll(): Record<string, FoldMark[]> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "{}") as Record<string, FoldMark[]>;
  } catch {
    return {};
  }
}

export function loadFolds(id: string): FoldMark[] {
  return readAll()[id] ?? [];
}

export function saveFolds(id: string, marks: FoldMark[]): void {
  const all = readAll();
  if (marks.length) all[id] = marks;
  else delete all[id];
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* Privatmodus o. ä. – Faltung bleibt dann eben nur für die Sitzung. */
  }
}

/** Kürzt eine Zeile auf den Vergleichs-Schnipsel. */
export function foldSnippet(line: string): string {
  return line.trim().slice(0, SNIPPET_LEN);
}
